export async function queryContentful<T extends Record<string, any>>(query: string): Promise<T> {
	const res = await fetch(
		'https://graphql.contentful.com/content/v1/spaces/e34g9w63217k/?query=' +
			encodeURIComponent(query),
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${atob('VFJsQ28xQmxUbXB3eUtJT0hKMDhYMmxZQWFOTmxjZUY0MTVLTW1La01Gaw==')}`,
			},
		}
	);
	if (!res.ok) throw new Error(await res.text());
	// console.trace('query cost', res.headers.get('x-contentful-graphql-query-cost'));
	return (await res.json()).data;
}

export interface Post {
	title: string;
	contentText: string;
	sys: {
		id: string;
		publishedAt: string;
	};
}

export interface Club {
	slug: string;
	name: string;
	tent: string | null;
	description: string | null;
	meetingLocation: string | null;
	meetingWhen: string | null;
	grades: string | null;
	clubWebsite: string | null;
	listingWebsite: string | null;
	tags: string[] | null;
}

let clubs: Club[] = [];
const clubQuery = `{
	clubCollection(order: name_ASC) {
		items {
			slug
			name
			tent
			description
			meetingLocation
			meetingWhen
			grades
			clubWebsite
			listingWebsite
			tags
		}
	}
}`;
export async function getClubs() {
	if (clubs.length === 0) {
		clubs = (await queryContentful(clubQuery)).clubCollection.items;
	}
	return clubs;
}

export const sponsorTiers = [
	'clover',
	'sky',
	'gold',
	'silver',
	'bronze',
	'copper',
	'automobile',
	'custom',
	'friends-family',
	'business-card',
	'inkind',
] as const;

export const sponsorTierName = (tier: (typeof sponsorTiers)[number]) =>
	tier === 'friends-family' ? 'Friends & Family'
	: tier === 'business-card' ? 'Business Card'
	: tier === 'inkind' ? 'In-Kind Donation'
	: tier.substring(0, 1).toUpperCase() + tier.substring(1);

export interface Sponsor {
	heading: string;
	image: { url: string } | null;
	description: string | null;
	link: string | null;
	tier: (typeof sponsorTiers)[number];
}

let sponsors: Sponsor[] = [];
const sponsorQuery = `{
	sponsorSpotCollection {
		items {
			heading
			image {
				url
			}
			description
			link
			tier
		}
	}
}`;
export async function getSponsors() {
	if (sponsors.length === 0) {
		sponsors = (await queryContentful(sponsorQuery)).sponsorSpotCollection.items;
	}
	return sponsors;
}
